export enum RawChatsSearchEvent {
  FIND_CHATS = 'FIND_CHATS',
  FIND_MESSAGES = 'FIND_MESSAGES',
  CLEAR = 'CLEAR',
}

export default RawChatsSearchEvent;
